
import { Base } from '../base-component';

import './product-filter-dropdown.component.scss';

import * as $ from 'jquery';

export class ProductFilterDropdown extends Base {

	currentFilter: string = "";
	filterItem: JQuery<HTMLElement>;
	depositInput: JQuery<HTMLElement>;
	slideRunner: JQuery<HTMLElement>;
	dropdown: JQuery<HTMLElement>;

	filterJson: any;
	productJson: any;

	constructor(element: Element) {

		super(element);

	}

	init() {

		let parseData = jsonData;
		this.filterJson = parseData.filters;
		this.productJson = parseData.products;

		this.depositInput = $('.product-filter-dropdown__deposit');
		this.filterItem = $('.product-filter-dropdown__item');
		this.slideRunner = $('.product-filter-dropdown__slide-runner');
		this.dropdown = $('.product-filter-dropdown__dropdown');

		$(document).ready(() => {

			this.currentFilter = this.filterItem.first().data('filter');
			this.moveSlideRunner(this.filterItem.first());

		});

	}

	bindEvents() {

		this.dropdown.click((e) => {
			$('.product-filter-dropdown__wrapper').toggleClass('product-filter-dropdown__wrapper--open');
		});

		this.depositInput.keyup((e) => {
			if ((this.depositInput.val() == '') || (this.depositInput.val().toString().length > 1)) {
				this.filterProducts(this.currentFilter);
			}
		});

		$(document).on('click', '.product-filter-dropdown__item', (e) => {
			let filter = $(e.currentTarget);
			this.currentFilter = filter.data('filter');

			this.moveSlideRunner(filter);

			$('.product-filter-dropdown__dropdown-value-text').text(this.currentFilter);
			$('.product-filter-dropdown__wrapper').removeClass('product-filter-dropdown__wrapper--open');
		});

		window.addEventListener('resize', this.debounce(() => {

			let currentFilterItem = $(`.product-filter-dropdown__item[data-filter='${this.currentFilter}']`);
			this.moveSlideRunner(currentFilterItem);

		}, 250, false));

		$(document).on('click', '.product-filter-dropdown__item', (e) => {
			let filter = $(e.currentTarget).data('filter');
			this.filterProducts(filter);
		});
	}

	filterProducts(tag) {
		let _deposit: any = this.depositInput.val();
		$('.product-card').addClass("product-card--hide");
		let filtered: any;
		filtered = this.productJson.filter((prod) => {
			let _tmpPrice = prod.pricing[0].title.replace( /\s/g, '');
			let _price = parseFloat(_tmpPrice);
			if (_deposit != '') {
				return ((prod.tags.indexOf(tag) == -1) || (_price > _deposit));
			} else {
				return (prod.tags.indexOf(tag) == -1);
			}
		});


		setTimeout(() => {
			$('.product-card[data-id]').removeClass("product-card--hide").removeClass('product-card--filtered');
			if (filtered.length > 0) {
				filtered.forEach(el => {
					$('.product-card[data-id="' + el.id + '"]').addClass("product-card--hide").addClass("product-card--filtered");
				});
			}
		}, 200);
	}



	moveSlideRunner(filter: JQuery<HTMLElement>) {

		let filterPositionLeft = filter.position().left;
		let filterWidth = filter.width();

		this.slideRunner
			.width(0)
			.css('left', `${filterPositionLeft + 35}px`)
			.show()
			.delay(350)
			.width(filterWidth);

	}

	debounce(func, wait, immediate) {
		let timeout;
		return function () {
			let context = this, args = arguments;
			let later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

}



// WEBPACK FOOTER //
// ./components/product-filter-dropdown/product-filter-dropdown.component.ts